import { Flag, ChatCircleText } from "@phosphor-icons/react";
import { MOVES, fmtClock, moveLabel } from "@/lib/format";

const SHOWN_FLAG = ["shown", "clicked", "replaced", "ignored"];

function timeline(r) {
  const answers = r.answers.filter((a) => a.status === "done").map((a) => ({ key: `answer:${a.n}`, kind: "answer", t: a.transcript_seconds || 0, ...a }));
  const flags = r.flags.filter((f) => SHOWN_FLAG.includes(f.status)).map((f) => ({ key: `flag:${f.id}`, kind: "flag", t: f.at_t || 0, text: f.reason, ...f }));
  return [...answers, ...flags].sort((a, b) => a.t - b.t);
}

const avgScore = (scores, key) => {
  const vals = ["a", "b"].map((s) => scores?.[s]?.[key]?.score).filter(Boolean);
  return vals.length ? (vals.reduce((x, y) => x + y, 0) / vals.length).toFixed(1) : null;
};

const Item = ({ it, scores }) => {
  const color = MOVES[it.move]?.color;
  const avg = avgScore(scores, it.key);
  const muted = it.kind === "answer" && !it.shown;
  return (
    <div className={`border p-4 space-y-2 ${muted ? "border-[var(--o-border-soft)] opacity-60" : "border-[var(--o-border)]"}`} data-testid={`compare-item-${it.key}`}>
      <div className="flex items-center gap-2 text-xs">
        {it.kind === "flag" ? <Flag size={12} weight="fill" className="text-[#FF3B30]" /> : <ChatCircleText size={12} />}
        <span className="font-mono">{it.kind === "flag" ? "Flag" : `#${String(it.n).padStart(2, "0")}`}</span>
        <span className="font-mono text-[var(--o-muted3)]">{fmtClock(it.t)}</span>
        {it.move && <span className="font-mono uppercase text-[10px]" style={{ color }}>{moveLabel(it.move)}</span>}
        <span className="ml-auto font-mono text-[10px] text-[var(--o-muted2)]">
          {it.kind === "answer" ? `u${it.usefulness}${it.shown ? "" : " · held"}` : `c${it.confidence} · ${it.status}`}
          {avg && <span className="ml-2 text-[var(--o-fg)]">★ {avg}</span>}
        </span>
      </div>
      {it.kind === "answer" && <p className="font-mono text-[10px] text-[var(--o-muted3)] truncate">Q · {it.question}</p>}
      <p className="text-sm leading-relaxed">{it.text || "—"}</p>
    </div>
  );
};

export const TimelineColumn = ({ record, label }) => {
  const items = timeline(record);
  return (
    <div className="space-y-3" data-testid={`timeline-${label}`}>
      <div className="flex items-baseline justify-between">
        <span className="font-display text-lg font-bold">{label}</span>
        <span className="font-mono text-[11px] text-[var(--o-muted2)]">{items.length} items · {record.turn_count} turns</span>
      </div>
      {items.length === 0 && <p className="text-sm text-[var(--o-muted3)]">No answers or flags.</p>}
      {items.map((it) => <Item key={it.key} it={it} scores={record.scores} />)}
    </div>
  );
};
